<template>
  <div id="app" class="app">
    <router-view />
    <TheTransition />
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <TheModal v-show="showImage" :active="showImage" />
    </transition>
  </div>
</template>

<script>
import scrollMonitor from 'scrollmonitor'
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { addListeners, removeListeners } from '@modules/event'
import TheTransition from '@blocks/TheTransition'
import TheModal from '@blocks/TheModal'

const breakpoints = [
  { name: 'small', min: 0, max: 767 },
  { name: 'medium', min: 768, max: 1023 },
  { name: 'large', min: 1024, max: 1440 },
  { name: 'xlarge', min: 1441, max: 20000 }
]

export default {
  components: {
    TheModal,
    TheTransition
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      breakpoint: 'breakpoints/getBreakpoint'
    }),
    ...mapState('modals', [
      'showImage'
    ])
  },
  created () {
    addListeners(window, 'resize', this.debouncedMethod)
  },
  mounted () {
    this.updateBreakpoints(breakpoints)
    this.updateWindowWidth(window.innerWidth)
  },
  methods: {
    ...mapActions({
      updateBreakpoints: 'breakpoints/updateBreakpoints',
      updateWindowWidth: 'breakpoints/updateWindowWidth'
    }),
    debouncedMethod: debounce(function () {
      this.handleWindowResize()
    }, 100),
    handleWindowResize () {
      this.updateWindowWidth(window.innerWidth)
      this.updateScrollMonitor()
    },
    updateScrollMonitor () {
      scrollMonitor.recalculateLocations()
      scrollMonitor.update()
    }
  },
  destroyed () {
    removeListeners(window, 'resize', this.debouncedMethod)
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/main/main.scss";

.app{
  width: 100%;
  min-height: 60rem;
  background-color: black;
  overflow: hidden;

  .main{
    .page{
      width: 100%;
      overflow: hidden;
    }
  }
}
</style>
